import React from "react";
import { Link } from "react-router-dom";
import { ListItem, ListItemText } from "@material-ui/core";
import "./Listas.css";
import { useNavigate } from "react-router-dom";
import { IconChevronRight, IconLogout } from "@tabler/icons";
import { Typography } from "@material-ui/core";
import { clearUserSession } from "../utils/logout";


function ObtenerMenuUsuario() {
  // console.log(window.sessionStorage.getItem("usuario"));
  const dataLogin = JSON.parse(window.sessionStorage.getItem("usuario"));
  return dataLogin.result.menus;
}

const Listas = (props) => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = React.useState({
    email: "",
    // Password: '',
  });
  // logout the user
  const handleLogout = () => {
    setUsuario({});
    // Usar función centralizada para limpiar sesión
    clearUserSession();

    // Flag para indicar que el usuario cerró sesión manualmente
    // Evita auto-login desde Azure SSO
    localStorage.setItem("manualLogout", "true");

    navigate("/");
  };
  const menu = ObtenerMenuUsuario();

  return (
    <>
      <div className="menu_principal_app">
        {
          [...menu].sort((a, b) => {
            const normalizedDescA = a.descripcion?.trim().toLowerCase().replace(/\s+/g, '');
            const normalizedDescB = b.descripcion?.trim().toLowerCase().replace(/\s+/g, '');

            const isHomeA = normalizedDescA === 'home';
            const isHomeB = normalizedDescB === 'home';

            if (isHomeA && !isHomeB) return -1;
            if (!isHomeA && isHomeB) return 1;
            return 0;
          }).map((item, pos) => (
          <div key={pos} className="botones_menu_principal">
            <Link to={item.url} className="botones_menu_principal">
              <ListItem
                  key={item.id} >
                 <IconChevronRight
                    size={15}
                    color="white"
                    stroke={3}
                    style={{ marginRight: "5px"}}
                 />
                <span>{item.descripcion}</span>
              </ListItem>
            </Link>
          </div>
          ))
        }
      </div>

      <div>
        <Link
          className="boton_salir_app"
          to="/"
          onClick={handleLogout}>
            <ListItem className="boton_salir_app">
                  <IconLogout
                    size={20}
                    color="white"
                    stroke={3}
                    style={{ marginRight: "7px"}}
                  />
                <ListItemText  primary="Cerrar sesión" />
          </ListItem>
        </Link>
      </div>
      <div>
        <Typography className="txt_version_white">Versión {process.env.REACT_APP_VERSION || '0'} – {process.env.REACT_APP_COMMIT_HASH || '0'} </Typography>
      </div>
    </>
  );
};

export default Listas;


